import { InjectionToken } from '@angular/core';

export const BACKEND_API_URL = new InjectionToken<string>('BACKEND_API_URL');
export const BACKEND_CLIENT_TAG = new InjectionToken<string>('BACKEND_CLIENT_TAG');
export const BACKEND_API_HOSTMASTERKEY = new InjectionToken<string>('BACKEND_API_HOSTMASTERKEY');
